import React, { useEffect, useState } from 'react';
import { Send, Smartphone, Mail, Phone, AlertCircle, Plus, Copy, CheckCircle2 } from 'lucide-react';
import { templates } from '../../data/templates';
export function MessageComposer() {
  const [selectedTemplate, setSelectedTemplate] = useState(templates[0]);
  const [variant, setVariant] = useState<'A' | 'B'>('A');
  const [content, setContent] = useState(templates[0].content);
  const [messagesToday, setMessagesToday] = useState(1);
  const [copied, setCopied] = useState(false);
  const maxMessages = 2;
  // Mock lead data for preview
  const mockLeadData = {
    '[Nombre]': 'María',
    '[Tu nombre]': 'Carlos',
    '[Ciudad]': 'Barcelona',
    '[Barrio]': 'Poble Sec',
    '[Nombre_Negocio]': 'La Tasquita de Enfrente'
  };
  useEffect(() => {
    // Apply variant logic (mocked)
    let newContent = selectedTemplate.content;
    if (variant === 'B') {
      newContent = newContent.replace('¿Le envío dos capturas', '¿Le gustaría ver dos capturas');
    }
    setContent(newContent);
  }, [selectedTemplate, variant]);
  const getPreviewContent = () => {
    let preview = content;
    Object.entries(mockLeadData).forEach(([key, value]) => {
      preview = preview.replaceAll(key, value);
    });
    return preview;
  };
  const getChannelIcon = (channel: string) => {
    switch (channel) {
      case 'WhatsApp':
        return <Smartphone className="w-4 h-4" data-id="element-167" />;
      case 'Email':
        return <Mail className="w-4 h-4" data-id="element-168" />;
      case 'Teléfono':
        return <Phone className="w-4 h-4" data-id="element-169" />;
      default:
        return <Smartphone className="w-4 h-4" data-id="element-170" />;
    }
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(getPreviewContent());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="card overflow-hidden flex flex-col lg:flex-row h-[700px]" data-id="element-171">
      {/* Left side - Editor */}
      <div className="w-full lg:w-1/2 border-r border-white/5 flex flex-col bg-growthly-surface" data-id="element-172">
        <div className="p-5 border-b border-white/5 bg-growthly-panel flex items-center justify-between" data-id="element-173">
          <div className="flex-1 mr-4" data-id="element-174">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1.5" data-id="element-175">
              Plantilla Activa
            </label>
            <select value={selectedTemplate.id} onChange={e => {
            const template = templates.find(t => t.id === e.target.value) || templates[0];
            setSelectedTemplate(template);
            setContent(template.content);
          }} className="input-field" data-id="element-176">
              {templates.map(t => <option key={t.id} value={t.id} data-id="element-177">
                  {t.name} ({t.channel})
                </option>)}
            </select>
          </div>
          <button className="mt-5 p-2 bg-white/5 text-growthly-text rounded-md hover:bg-white/10 transition-colors flex items-center justify-center" data-id="element-178">
            <Plus className="w-4 h-4" data-id="element-179" />
          </button>
        </div>

        <div className="p-5 border-b border-white/5 flex items-center justify-between bg-growthly-bg/50" data-id="element-180">
          <div className="flex space-x-2" data-id="element-181">
            <button onClick={() => setVariant('A')} className={`px-4 py-1.5 text-[12px] font-medium rounded-md transition-colors ${variant === 'A' ? 'bg-growthly-amber text-growthly-bg' : 'bg-white/5 text-growthly-muted hover:bg-white/10'}`} data-id="element-182">
              Variante A
            </button>
            <button onClick={() => setVariant('B')} className={`px-4 py-1.5 text-[12px] font-medium rounded-md transition-colors ${variant === 'B' ? 'bg-growthly-amber text-growthly-bg' : 'bg-white/5 text-growthly-muted hover:bg-white/10'}`} data-id="element-183">
              Variante B
            </button>
          </div>
          <div className="flex items-center text-[12px] text-growthly-amber/80 bg-growthly-amber/10 px-3 py-1 rounded-full" data-id="element-184">
            <AlertCircle className="w-3 h-3 mr-1.5" data-id="element-185" />
            A/B Test Activo
          </div>
        </div>

        <div className="p-5 flex-1 flex flex-col" data-id="element-186">
          <div className="flex items-center justify-between mb-2" data-id="element-187">
            <label className="block text-[12px] font-medium text-growthly-muted" data-id="element-188">
              Mensaje
            </label>
            <span className="text-[11px] text-growthly-muted" data-id="element-189">
              {content.length} caracteres
            </span>
          </div>
          <textarea value={content} onChange={e => setContent(e.target.value)} className="input-field flex-1 resize-none font-mono text-[13px] leading-relaxed" data-id="element-190" />

          <div className="mt-4" data-id="element-191">
            <label className="block text-[12px] font-medium text-growthly-muted mb-2" data-id="element-192">
              Variables disponibles
            </label>
            <div className="flex flex-wrap gap-2" data-id="element-193">
              {Object.keys(mockLeadData).map(variable => <button key={variable} onClick={() => setContent(prev => prev + ' ' + variable)} className="text-[11px] font-medium bg-white/5 border border-white/10 px-2.5 py-1.5 rounded text-growthly-text hover:bg-white/10 hover:border-white/20 transition-all" data-id="element-194">
                  {variable}
                </button>)}
            </div>
          </div>
        </div>

        <div className="p-5 border-t border-white/5 bg-growthly-panel flex items-center justify-between" data-id="element-195">
          <div className="flex items-center" data-id="element-196">
            <div className={`w-2 h-2 rounded-full mr-2 ${messagesToday >= maxMessages ? 'bg-growthly-red' : 'bg-growthly-green'}`} data-id="element-197"></div>
            <span className="text-[12px] font-medium text-growthly-text" data-id="element-198">
              Límite diario: {messagesToday}/{maxMessages}
            </span>
          </div>
          <div className="flex space-x-3" data-id="element-199">
            <button onClick={handleCopy} className="btn-secondary inline-flex items-center" data-id="element-200">
              {copied ? <CheckCircle2 className="w-4 h-4 mr-2 text-growthly-green" data-id="element-201" /> : <Copy className="w-4 h-4 mr-2" data-id="element-202" />}
              {copied ? 'Copiado' : 'Copiar'}
            </button>
            <button disabled={messagesToday >= maxMessages} className={`btn-primary inline-flex items-center ${messagesToday >= maxMessages ? 'bg-white/10 text-growthly-muted cursor-not-allowed' : ''}`} data-id="element-203">
              <Send className="w-4 h-4 mr-2" data-id="element-204" />
              Enviar
            </button>
          </div>
        </div>
      </div>

      {/* Right side - Preview (WhatsApp Style) */}
      <div className="w-full lg:w-1/2 bg-[#0B141A] flex flex-col relative border-l border-white/5" data-id="element-205">
        <div className="bg-[#202C33] text-[#E9EDEF] p-4 flex items-center shadow-md z-10" data-id="element-206">
          <div className="w-10 h-10 bg-[#6B7C85] rounded-full flex items-center justify-center mr-4" data-id="element-207">
            <UserIcon data-id="element-208" />
          </div>
          <div className="flex-1" data-id="element-209">
            <div className="text-[15px] font-medium" data-id="element-210">
              La Tasquita de Enfrente
            </div>
            <div className="text-[12px] text-[#8696A0]" data-id="element-211">María (Gerente)</div>
          </div>
          <div className="flex space-x-4 text-[#AEBAC1]" data-id="element-212">
            <Phone className="w-5 h-5" data-id="element-213" />
            <MoreVerticalIcon data-id="element-214" />
          </div>
        </div>

        <div className="flex-1 p-6 overflow-y-auto flex flex-col justify-end pb-8 bg-[url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')] bg-repeat bg-opacity-10" style={{
        backgroundBlendMode: 'overlay',
        backgroundColor: '#0B141A'
      }} data-id="element-215">
          <div className="text-center mb-6" data-id="element-216">
            <span className="bg-[#182229] text-[#8696A0] text-[11px] px-3 py-1 rounded-lg uppercase tracking-wide" data-id="element-217">
              Hoy
            </span>
          </div>

          <div className="bg-[#005C4B] text-[#E9EDEF] p-2.5 rounded-lg rounded-tr-none max-w-[85%] self-end shadow-sm relative text-[14px] whitespace-pre-wrap leading-relaxed" data-id="element-218">
            {getPreviewContent()}
            <div className="text-[10px] text-right text-[#8696A0] mt-1 flex items-center justify-end" data-id="element-219">
              10:42 <CheckDoubleIcon className="w-4 h-4 ml-1 text-[#53BDEB]" data-id="element-220" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}
function MoreVerticalIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-221">
      <circle cx="12" cy="12" r="1" data-id="element-222"></circle>
      <circle cx="12" cy="5" r="1" data-id="element-223"></circle>
      <circle cx="12" cy="19" r="1" data-id="element-224"></circle>
    </svg>;
}
function CheckDoubleIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-225">
      <polyline points="18 6 7 17 2 12" data-id="element-226"></polyline>
      <polyline points="22 6 11 17 9 15" data-id="element-227"></polyline>
    </svg>;
}
function UserIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-228">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" data-id="element-229"></path>
      <circle cx="12" cy="7" r="4" data-id="element-230"></circle>
    </svg>;
}